// NavigationButtons.jsx
import React from "react";

const NavigationButtons = ({
  page,
  nextPage,
  handleResetFiles,
  preventPage,
  handleSubmit,
}) => {
  return (
    <>
      {page === 0 ? (
        <div className="d-flex flex-column align-items-center justify-content-center">
          <div className="divider mt-5 mb-5"></div>
          <div className="row d-flex justify-content-center">
            <button
              type="button"
              className="btn btn-warning btn-md"
              onClick={nextPage}
            >
              Déposer une demande
            </button>
          </div>
        </div>
      ) : (
        page < 6 && (
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div className="divider mt-5 mb-5"></div>
            <div
              className="modal fade"
              id="modalResetFiles"
              tabIndex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header border-0">
                    <h5 className="modal-title">
                      Le retour à la page précédente supprimera toutes les
                      pièces jointes
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p>
                      Êtes-vous sur de vouloir revenir à la page précédente ?
                    </p>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-warning btn-md"
                      data-bs-dismiss="modal"
                    >
                      Annuler
                    </button>
                    <button
                      type="button"
                      className="btn btn-warning btn-md"
                      onClick={() => {
                        handleResetFiles();
                        preventPage();
                      }}
                      data-bs-dismiss="modal"
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex justify-content-center">
              {page === 4 || page === 5 ? (
                <div className="col-6">
                  <div
                    className="btn btn-outline-warning btn-md navigationBtn"
                    data-bs-toggle="modal"
                    data-bs-target="#modalResetFiles"
                  >
                    Retour
                  </div>
                </div>
              ) : (
                <div className="col-6">
                  <div
                    className="btn btn-outline-warning btn-md"
                    onClick={preventPage}
                  >
                    Retour
                  </div>
                </div>
              )}
              {page === 5 ? (
                <div className="col-6">
                  <input
                    type="button"
                    className="btn btn-warning btn-md navigationBtn"
                    value="Valider"
                    onClick={() => {
                      handleSubmit();
                    }}
                  />
                </div>
              ) : (
                <div className="col-6">
                  <button
                    type="button"
                    className="btn btn-warning btn-md"
                    onClick={nextPage}
                  >
                    {page === 4 ? "Vérifier" : "Suivant"}
                  </button>
                </div>
              )}
            </div>
          </div>
        )
      )}
    </>
  );
};

export default NavigationButtons;
